import { makeStyles, fade } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  paperMobile: {
    color: (props) =>
      props.eventStyles.sidebar_font_color ? props.eventStyles.sidebar_font_color : '#4A4A4A',
    backgroundColor: (props) =>
      props.eventStyles.sidebar_color ? props.eventStyles.sidebar_color : '#3BBBE6',
    fontSize: '0.875rem',
    lineHeight: '1.125rem',
    padding: 8,
  },
  box: { display: 'flex', alignItems: 'center' },
  boxName: {
    flex: '1 1 auto',
    padding: '0 12px 0 8px',
    fontWeight: 600,
    '& .days': { fontSize: '0.8125rem', lineHeight: '1rem', fontWeight: 500 },
  },
  boxFix: { flex: '0 0 auto' },
  iconMore: {
    fontSize: '1.5rem',
  },
  iconButton: {
    padding: 0,
    color: (props) =>
      props.eventStyles.sidebar_font_color ? props.eventStyles.sidebar_font_color : '#FFFFFF',
  },
  popper: {
    zIndex: 3,
  },
  paperPopup: {
    minWidth: '125px',
    maxWidth: '125px',
    marginTop: '8px',
    boxShadow: '0px 0px 10px rgba(74, 74, 74, 0.25)',
    borderRadius: 5,
  },
  rootList: {
    padding: '4px',
  },
  rootListItem: {
    color: '#4A4A4A',
    padding: '8px',
    '&:hover': {
      backgroundColor: '#FFF',
      color: '#4A4A4A',
      borderRadius: 5,
    },
  },
  rootListItemText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: '1rem',
  },
  avatar: {
    width: '30px',
    height: '30px',
    backgroundColor: '#F4F4F4',
  },
  avatarIcon: {
    fontSize: '1.25rem !important',
    color: '#9B9B9B',
  },
  eventBox: {
    display: 'flex',
    [theme.breakpoints.down("sm")]: {
      marginTop: 16,
    },
  },
  eventBoxDate: {
    flex: '0 0 auto',
    padding: 16,
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    letterSpacing: '0.5px',
    textAlign: 'center',
    color: (props) =>
      props.eventStyles.sidebar_font_color ? props.eventStyles.sidebar_font_color : '#4A4A4A',
    backgroundColor: (props) =>
      props.eventStyles.sidebar_color ? props.eventStyles.sidebar_color : '#3BBBE6',
    borderRadius: 5,
    boxShadow: '0 0 10px 0 rgba(155, 155, 155, 0.3)',
    '& .days': {
      fontWeight: 300,
      fontSize: '1.875rem',
      lineHeight: '1.5rem',
    },
    '& .day': {
      fontWeight: 600,
    },
  },
  eventBoxName: {
    flex: '1 1 auto',
    marginLeft: 12,
    padding: 16,
    fontSize: '1.375rem',
    lineHeight: '1.5rem',
    color: (props) =>
      props.eventStyles.sidebar_font_color ? props.eventStyles.sidebar_font_color : '#4A4A4A',
    backgroundColor: (props) =>
      props.eventStyles.sidebar_color ? props.eventStyles.sidebar_color : '#3BBBE6',
    borderRadius: 5,
    boxShadow: '0 0 10px 0 rgba(155, 155, 155, 0.3)',  
    [theme.breakpoints.down("sm")]: {
      fontSize: '1.5rem',
      lineHeight: '2rem',
      fontWeight: 'normal',
    },
  },
}))

export default useStyles
